
import React from "react";

/**
 * PageWindow wraps page content.
 * Breadcrumb and page title are now handled by TopBar.
 */
export default function PageWindow({ children }) {
  return <div className="page-window">{children}</div>;
}
